"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIX_RECAPTCHA_LANGUAGE_MAP = void 0;
exports.WIX_RECAPTCHA_LANGUAGE_MAP = {
    de: 'de',
    en: 'en',
    es: 'es',
    fr: 'fr',
    it: 'it',
    ja: 'ja',
    ko: 'ko',
    pl: 'pl',
    ru: 'ru',
    nl: 'nl',
    tr: 'tr',
    sv: 'sv',
    pt: 'pt',
    no: 'no',
    da: 'da',
    hi: 'hi',
    zh: 'zh',
    cs: 'cs',
    th: 'th',
    he: 'iw',
};
//# sourceMappingURL=constants.js.map